import colors from '../colors';
export var MuiTabs = {
    styleOverrides: {
        root: {
            position: 'relative',
            minHeight: 'auto',
            height: '32px',
            '& .MuiTabs-flexContainer': {
                gap: '24px',
                height: '100%',
            },
            '& .MuiTabScrollButton-root': {
                //scroll buttons styles
                width: '62px',
                height: '100%',
                position: 'absolute',
                zIndex: 2,
                opacity: 1,
                '&.Mui-disabled': {
                    display: 'none',
                },
                '&:first-of-type': {
                    background: "linear-gradient(90deg, ".concat(colors.white, " 62.43%, rgba(255, 255, 255, 0) 100%)"),
                    justifyContent: 'start',
                    left: 0,
                },
                '&:last-child': {
                    background: "linear-gradient(270deg, ".concat(colors.white, " 62.43%, rgba(255, 255, 255, 0) 100%)"),
                    justifyContent: 'end',
                    right: 0,
                },
                svg: {
                    background: colors.white,
                    border: "1px solid ".concat(colors.grey[300]),
                    borderRadius: '50%',
                },
            },
        },
    },
};
